import React from 'react';
import { connect } from 'react-redux';

class F_2 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    gotoNextStep(e) {
        e.preventDefault();

        if(e.target.dataset['clear']) {
            this.props.saveValues({userIdentificationNumber: ''});            
        }

        this.props.nextStep(e.target.dataset['next']);
    }

    render() {
        return (
            <div className="click2call--groups">
                <div className="click2call--group click2call--group-label">
                    <p>Czy sprawa dotyczy numeru na który jesteś zalogowany?</p>
                    <p className="phonenumber">{this.props.call.registration.msisdn || this.props.call.registration.product_number}</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-choice">
                        <button id={`hash${Math.random()}`} onClick={this.gotoNextStep} data-next="F_4">Tak</button>
                        <button id={`hash${Math.random()}`} onClick={this.gotoNextStep} data-next="F_3" data-clear={true}>Nie</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        call: state.call
    };
};

export default connect(mapStateToProps)(F_2);